/**
 * Billing fields on tenant create. Provider customer ids are written later,
 * after the tenant row exists.
 */
export class CreateTenantBillingDto {
  enableMetering?: boolean;
  /** Start of the trial window. Null if the tenant is not starting on a trial. */
  trialStartsAt?: string | null;
  /**
   * Instant capture starts emitting for this tenant (trial end when
   * `trialStartsAt` is set). Null means emit nothing until a later update.
   */
  meteringStartsAt?: string | null;
}
